export default "__VITE_ASSET__BMqSSa6l__"